"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _definitionhelpers = require("../../../utils/definitionhelpers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- ToolTIP : DEFINITION --------------- ++++++++++ */


var _default = {
  name: 'ToolTip',
  group: _definitionhelpers.groupNames.messages,
  props: {
    delay: {
      type: 'number'
    },
    open: {
      type: 'boolean',
      default: false,
      options: [true, false]
    },
    position: {
      type: 'string',
      default: 'top',
      options: ['top', 'bottom', 'left', 'right', 'top-start', 'bottom-start', 'left-start', 'right-start', 'top-end', 'bottom-end', 'left-end', 'right-end']
    },
    trigger: {
      type: 'string',
      default: 'mouseenter focus',
      options: ['mouseenter focus', 'mouseenter', 'focus', 'click', 'manual']
    },
    content: {
      type: 'object',
      default: "Online"
    },
    children: {
      type: 'object',
      default: _react.default.createElement("p", null, "This is a ToolTip")
    },
    zIndex: {
      type: 'number',
      default: 9999
    }
  }
};
exports.default = _default;